import {
    sizeTinyHeader,
    sizeSmallHeader,
    sizeMediumHeader,
    sizeLargeHeader,
    sizeVeryLargeHeader,
    sizeHugeHeader,
    sizeEnormousHeader,
} from './getGroupHeaderForSortBySize.locstring.json';
import loc from 'owa-localize';
import type GroupHeader from '../type/GroupHeader';
import { SizeHeaderId } from '../type/GroupHeaderId';
import type { TableView } from 'owa-mail-list-store';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';

const sizeGroupHeaders: SizeGroupHeader[] = [];

export interface SizeGroupHeader extends GroupHeader {
    greaterThanSize: number;
}

function initializeSizeGroupHeaders() {
    sizeGroupHeaders.push(
        {
            headerId: SizeHeaderId.Tiny,
            headerText: () => loc(sizeTinyHeader),
            greaterThanSize: 0, // There should not exist a row with size 0
        },
        {
            headerId: SizeHeaderId.Small,
            headerText: () => loc(sizeSmallHeader),
            greaterThanSize: 1024 * 10,
        },
        {
            headerId: SizeHeaderId.Medium,
            headerText: () => loc(sizeMediumHeader),
            greaterThanSize: 1024 * 25,
        },
        {
            headerId: SizeHeaderId.Large,
            headerText: () => loc(sizeLargeHeader),
            greaterThanSize: 1024 * 1024,
        },
        {
            headerId: SizeHeaderId.VeryLarge,
            headerText: () => loc(sizeVeryLargeHeader),
            greaterThanSize: 1024 * 1024 * 5,
        },
        {
            headerId: SizeHeaderId.Huge,
            headerText: () => loc(sizeHugeHeader),
            greaterThanSize: 1024 * 1024 * 10,
        },
        {
            headerId: SizeHeaderId.Enormous,
            headerText: () => loc(sizeEnormousHeader),
            greaterThanSize: 1024 * 1024 * 25,
        }
    );
}

/**
 * Get GroupHeader for row
 * @param rowKey rowKey for which we want to lookup time group range
 * @param tableView tableView
 * @return group header
 */
export default function getGroupHeaderForSortBySize(
    rowKey: string,
    tableView: TableView
): SizeGroupHeader {
    if (sizeGroupHeaders.length == 0) {
        initializeSizeGroupHeaders();
    }

    const rowSize = MailRowDataPropertyGetter.getSize(rowKey, tableView);
    for (let i = sizeGroupHeaders.length - 1; i >= 0; i--) {
        if (rowSize > sizeGroupHeaders[i].greaterThanSize) {
            return sizeGroupHeaders[i];
        }
    }

    return {
        headerText: sizeGroupHeaders[0].headerText,
        headerId: sizeGroupHeaders[0].headerId,
        greaterThanSize: sizeGroupHeaders[0].greaterThanSize,
    };
}
